import React from "react";
import SourceSelectorContainer from "containers/common/SourceSelector";

const CorpTypeSourceSelector = props => <SourceSelectorContainer {...props} />;
export default CorpTypeSourceSelector;
